export default {
  LOAD_STUDY_PLAN_CYCLE_DEPARTMENT_LIST_START: 'LoadStudyPlanCycleDepartmentListStart',
  LOAD_STUDY_PLAN_CYCLE_DEPARTMENT_LIST_END: 'LoadStudyPlanCycleDepartmentListEnd',
  TOGGLE_STUDY_PLAN_CYCLE_DEPARTMENT_CONFIRM_DIALOG: 'ToggleStudyPlanCycleDepartmentConfirmDialog'
};